import Vue from 'vue';
import {
    checkCCM19Consent,
    checkOneTrustConsentByWindowChange,
    handleClickOnDisclaimerLink,
    normalizeModelName,
} from '../utils';

Vue.component('model-page-component', {
    props: {
        model: {
            type: String,
        },
        entryId: {
            type: String,
        },
    },

    computed: {
        toggleSubtitleTooltipActiveClass: function () {
            return this.toggleClassOnPropChange(this.isSubtitleTooltipVisible);
        },
        togglePriceTooltipActiveClass: function () {
            return this.toggleClassOnPropChange(this.isPriceTooltipVisible);
        },
    },

    data() {
        return {
            isSubtitleTooltipVisible: false,
            isPriceTooltipVisible: false,
        };
    },

    mounted() {
        window.addEventListener('click', handleClickOnDisclaimerLink);

        if (checkCCM19Consent()) {
            this.handlePushToDatalayer();
        }

        window.addEventListener('click', this.handleOnElementOutsideClick);

        setTimeout(() => {
            if (
                !checkOneTrustConsentByWindowChange(window.OnetrustActiveGroups)
            ) {
                return;
            }
            this.handlePushToDatalayer();
        }, [1000]);
    },

    destroyed() {
        window.removeEventListener('click', this.handleOnElementOutsideClick);
    },

    methods: {
        handlePushToDatalayer() {
            if (!window.dataLayer) {
                window.dataLayer = window.dataLayer || [];
            }

            window.dataLayer.push(
                {
                    pageType: 'Showroom',
                    model: normalizeModelName(this.model),
                },
                {
                    event: 'view_car',
                    car: {
                        name: normalizeModelName(this.model),
                        ids: [this.entryId],
                    },
                },
            );
        },

        closePriceTooltip() {
            this.isPriceTooltipVisible = false;
        },

        closeSubtitleTooltip() {
            this.isSubtitleTooltipVisible = false;
        },

        toggleClassOnPropChange(prop) {
            return prop ? 'model-header__toolbar-text--active' : '';
        },

        handleOnElementOutsideClick(event) {
            this.handleTooltipOutsideClick(
                '.model-header__subtitle-wrapper',
                event,
                this.closeSubtitleTooltip,
            );

            this.handleTooltipOutsideClick(
                '.model-header__price-wrapper',
                event,
                this.closePriceTooltip,
            );
        },

        handleTooltipOutsideClick(className, event, callback) {
            const tooltip = document.querySelector(className);
            if (!tooltip) return;

            const isClickInsideTooltip = tooltip.contains(event.target);
            if (!isClickInsideTooltip) {
                callback();
            }
        },

        toggleSubtitleTooltip() {
            this.isSubtitleTooltipVisible = !this.isSubtitleTooltipVisible;
        },

        togglePriceTooltip() {
            this.isPriceTooltipVisible = !this.isPriceTooltipVisible;
        },
    },
});
